<template>
  <div class="container-fluid">
    <div class="row game_penalty_page">
      <div class="container postgame">
        <div class="game_section">
          <div class="header">
            <div class="points_block"></div>
          </div>

          <h1>{{ getTranslations.page_penalty_pre_game_title }}</h1>

          <h2>{{getTranslations.page_penalty_pre_game_description}}</h2>

          <img src="/static/images/bg_menu.png" class="iframe_cover">

          <button type="button" @click="handlePlayPenaltyGame">
            {{ getTranslations.page_penalty_pre_game_button_proceed }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'PenaltyPreGame',
  beforeRouteLeave (to, _from, next) {
    if (to.name !== 'penaltyAddOnGame') {
      this.resetAddOnGameData();
    }

    next();
  },
  computed:{
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  methods: {
    ...mapMutations('game', ['resetAddOnGameData']),
    handlePlayPenaltyGame () {
      this.$router.replace({ name: 'penaltyAddOnGame' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOn/PenaltyPreGame.vue